<template>
    <div class="thankyou-content">
        <h3 class="dark-title">Îți mulțumim!</h3>
        <h3 v-if="payment.status" class="light-title">{{ payment.status.message }}</h3>
        <h3 v-else-if="isRedirect && countDown > 0" class="light-title">Vei fi redirecționat pe pagina procesatorului de plăți în</h3>
        <h3 v-else class="light-title">Solicitarea ta a fost transmisă</h3>
        <p v-if="paymentMethod === 'bank_transfer'">
            Vei primi prin e-mail contractul și factura. Plata se realizează prin OP (transfer bancar)
            Documentele financiare le vei regăsi și în secțiunea <router-link to="/aplicatii/m3-sketch/licente/contracte-facturi">Contracte și facturi</router-link>
        </p>
        <div v-if="paymentMethod === 'mobilpay' && ! isRedirect" class="plata-card">
            <p>
                Documentele financiare le vei regăsi și în secțiunea <router-link to="/aplicatii/m3-sketch/licente/contracte-facturi">Contracte și facturi</router-link>
            </p>
        </div>
        <div class="plata-card">
            <div v-if="isRedirect" class="flex flex-column justify-content-center redirect-message">
                <form ref="formPaymentRedirect" method="post" :action="redirect.url">
                    <input type="hidden" name="env_key" :value="redirect.env_key">
                    <input type="hidden" name="data" :value="redirect.data">
                </form>
                <p v-if="countDown > 0" class="yellow-text" style="font-size: 28px;">
                    <strong v-html="countDown"></strong>
                    <span v-if="typeof countDown === 'number'" class="yellow-text"> secunde</span>
                </p>
                <p v-if="countDown == 0">Nu ai fost redirectionat?</p>
                <div v-if="countDown == 0" class="fake-input">
                    <p @click.prevent="submitForm"><strong>Apasa aici</strong></p>
                </div>
            </div>
        </div>
        <p>Licențele sunt universale. Vei aloca licența către o companie, în secțiunea <router-link to="/aplicatii/m3-sketch/licente/licentele-mele">Licențele mele</router-link></p>

        <img src="@/assets/images/M3/M3Sketch/poc_sketch_wide.png" class="mt-5">
    </div>
</template>

<script>

    import {BFormRadioGroup, BFormRadio, BButton} from "bootstrap-vue";

    export default {
        components: {
            BFormRadioGroup,
            BFormRadio,
            BButton,
        },

        props: ['redirect', 'payment', 'paymentMethod'],

        data() {
            return {
                countDown: 3
            }
        },

        computed: {
            isRedirect() {
                return Object.keys(this.redirect).length != 0;
            },

            isCompleted() {
                return Object.keys(this.payment).length != 0;
            },
        },

        mounted() {
            this.countdown()
        },

        methods: {
            countdown() {
                if(this.isRedirect && this.countDown > 0) {
                    setTimeout(() => {
                        this.countDown -= 1
                        this.countdown()
                        if(this.countDown === 0) {
                            this.submitForm()
                        }
                    }, 1000)
                }
            },

            submitForm() {
                this.$refs.formPaymentRedirect.submit()
            },
        },
    }
</script>

<style scoped>
.thankyou-content {
    height: 60vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.fake-input {
    cursor: pointer;
}

.dark-title {
    font-size: 25px;
    margin-bottom: 5px;
    line-height: 1;
    font-weight: 600;
    color: #5b607a;
}

.light-title {
    font-size: 25px;
    line-height: 1;
    color: #5b607a;
    font-weight: inherit;
    margin-bottom: 30px;
}

p {
    font-size: 18px;
    margin-bottom: 20px;
    color: #5b607a;
    text-align: center;
    max-width: 810px;
}

a {
    color: #02c199;
    font-weight: 600;
}

a:hover {
    text-decoration: none;
}
</style>